<template>
    <div class="mid-pane">
        <!--    Mobile left Pane-->
        <mobile-left-bar></mobile-left-bar>
        <!--    Mobile left Pane END-->

        <div class="hold">
            <!--        NavBar-->
            <div class="nav-bar">
                <div class="nav-hold">
                    <div class="back-icon" @click="backButton()">
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.1 31.1">
                        <path d="M30.2 16.4H0.9C0.4 16.4 0 16 0 15.5c0-0.5 0.4-0.9 0.9-0.9h29.3c0.5 0 0.9 0.4 0.9 0.9C31.1 16 30.7 16.4 30.2 16.4z" class="a"></path>
                        <path d="M16 31.1c-0.2 0-0.4-0.1-0.6-0.2L0.3 16.2C0.1 16 0 15.8 0 15.5c0-0.2 0.1-0.5 0.3-0.6L15.4 0.3c0.4-0.3 0.9-0.3 1.3 0 0.3 0.4 0.3 0.9 0 1.3L2.2 15.5l14.5 14c0.4 0.3 0.4 0.9 0 1.3C16.5 31 16.2 31.1 16 31.1z"></path>
                    </svg>
                </span>
                    </div>

                    <div class="nav-text">
                        <p class="main">Pay Bills</p>
                        <!--<p class="sub">From me to me</p>-->
                        <p class="sub">Mobile Data</p>
                    </div>
                </div>
            </div>


            <!--        Intro Text-->
            <div class="form-component">

                <div class="card mb-4">
                    <div class="card-body">
                        <!--<div class="card-title">From Me TO Me</div>-->
                        <div class="card-title">Mobile Data</div>
                        <!--<p>-->
                        <!--{{getFullBankList}}-->
                        <!--</p>-->
                        <div class="card-content">
                            <form @submit.prevent="fundsTransferStep1">
                                <div class="alert-box">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <ui-alert @dismiss="alert.show = false" :type="alert.type" v-show="alert.show">
                                                {{alert.message}}
                                            </ui-alert>
                                        </div>
                                    </div>
                                </div>

                                <!--<form>-->
                                <div class="row">
                                    <div class="col-md-6 form-group mb-2">
                                        <!--<accounts-select-box></accounts-select-box>-->
                                        <label>Debit Account*</label>
                                        <ui-select
                                                ref="debitAccountSelect"
                                                placeholder="Select Debit Account"
                                                type="basic"
                                                :options="dat"
                                                error="You must select at least 1 colours"
                                                :invalid="debitAcctTouched && debitAcct.length < 1"
                                                @touch="debitAcctTouched = true"
                                                v-model="debitAcct"
                                        ></ui-select>
                                    </div>

                                    <div class="col-md-6 form-group mb-2">
                                        <!--<label for="credit-account">Credit Account*</label>-->


                                        <label class="form-label">Phone Number </label>
                                        <input type="text" class="form-control" id="phonenumber" name="phonenumber"
                                               placeholder="Enter Phone Number" v-model="phonenumber"
                                               data-vv-name="Phone Number" v-on:keypress="isNumber($event)"
                                               required v-validate="'required|numeric|max:14|min:10'"
                                        >
                                        <span v-show="errors.has('phonenumber')" class="error-span is-danger">{{ errors.first('phonenumber') }}</span>
                                    </div>

                                    <div class="col-md-6 form-group mb-2">
                                        <label>Network*</label>
                                        <ui-select
                                                ref="creditBankSelect"
                                                placeholder="Select Network"
                                                type="image" minLength="1"
                                                :options="supportedNetworks"
                                                :invalid="networkTouched && network.length < 1"
                                                @touch="networkTouched = true"
                                                v-model="network"
                                                @change="popDataBundle"
                                        ></ui-select>
                                    </div>

                                    <div class="col-md-6 form-group mb-2">
                                        <label>Data Bundle*</label>
                                        <ui-select
                                                ref="dataBundleSelect"
                                                placeholder="Select Data Bundle"
                                                type="basic"
                                                :options="datbund"
                                                @touch="dataBundleTouched = true"
                                                v-model="dataBundle"
                                        ></ui-select>
                                    </div>

                                    <div class="col-md-12">
                                        <button class="btn btn-primary btn-xnax push-right">Submit</button>
                                    </div>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>

            </div>

            <footer-mobile></footer-mobile>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'

    import VueTelInput from 'vue-tel-input';
    import MobileLeftBar from '../sidebar/MobileLeftBar'
    import FooterMobile from "../utility/FooterMobile";


    export default {
        name: "Airtime",
        components: {FooterMobile, MobileLeftBar},
        props: {
            mobileLeftBar: MobileLeftBar,
        },
        data () {
            return {
                debitAcct:  '',
                debitAcctTouched:  false,
                phonenumber: '',
                network: '',
                networkTouched:  false,
                supportedNetworks: [
                    {
                        label: '9Mobile',
                        value: '9mobile',
                        image: 'https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/9mobile-logo.png'
                    },
                    {
                        label: 'Airtel',
                        value: 'airtel',
                        image: 'https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/airtel-logo.png'
                    },
                    {
                        label: 'Glo',
                        value: 'glo',
                        image: 'https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/glo-logo.png'
                    },
                    {
                        label: 'MTN',
                        value: 'mtn',
                        image: 'https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/mtn-logo.png'
                    },
                ],

                dataBundle: '',
                dataBundleTouched:  false,
                biller: [],

                postBody: {},

                dat: [],
                datbund: [],

                alert: {
                    show: false,
                    type: 'error',
                    message: 'Something Went Wrong!'
                },
            }
        },
        computed: {
            ...mapGetters([
                'getSideBarPage',
                'getInsideCurrentPage',
                'getDataOnLogin',
                'getMobileDataBiller',
                'getUsername',
            ])
        },
        created () {
            this.popDebitAcct()

            this.phonenumber = this.getDataOnLogin.mobilenumber
        },
        methods: {
            ...mapActions([
                'updateSideBarPage',
                'updateAppLoading',
                'updateInsideCurrentPage',
                'updateConfirmationPageBody',
            ]),

            backButton(){
                this.updateInsideCurrentPage('payBills')
            },
            showAlert(show, type, message){
                this.alert.show = show;
                this.alert.type = type;
                this.alert.message = message;
            },
            openModal(ref) {
                this.$refs[ref].open();
            },
            closeModal(ref) {
                this.$refs[ref].close();
            },


            generateUUID () {
                let d = new Date().getTime();
                let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    let r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
                });
                localStorage.test = uuid;
                return uuid
            },
            isNumber(evt) {
                evt = (evt) ? evt : window.event;
                let charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            clearKeenUiSelect(ref) {
                this.$refs[ref].clearSelection();
            },
            popDebitAcct(){
                let sdat = [];
                let sample = {};

                for (let i = 0; i < this.getDataOnLogin.accountlist.length; i++){

                    if (this.getDataOnLogin.accountlist[i].account_type === 'IBANKER'){}
                    else {
                        sample.label = this.getDataOnLogin.accountlist[i].accountno + " - ₦" + this.$options.filters.moneyFormat(this.getDataOnLogin.accountlist[i].availablebalance);
                        sample.value = this.getDataOnLogin.accountlist[i];

                        sdat.push(sample)

                        sample = {}
                    }
                }
                this.dat = sdat;
            },

            popDataBundle(){
                this.datbund = [];
                this.dataBundle = '';
                this.biller = [];

                let sdat = [];
                let sample = {};
                if (this.network.value === 'mtn'){
                    this.biller = ['BIL108', 'MTN DATA BUNDLE', 'mtn' ];
                    for (let i = 0; i < this.getMobileDataBiller.mtn.products.length; i++){

                        sample.label = this.getMobileDataBiller.mtn.products[i].name + " @ ₦" + this.$options.filters.moneyFormat(this.getMobileDataBiller.mtn.products[i].amount);
                        sample.value = this.getMobileDataBiller.mtn.products[i]

                        sdat.push(sample)

                        sample = {}
                    }
                    this.datbund = sdat;
                }
                else if (this.network.value === 'glo'){
                    this.biller = ['BIL109', 'GLO DATA BUNDLE', 'glo' ];
                    for (let i = 0; i < this.getMobileDataBiller.glo.products.length; i++){

                        sample.label = this.getMobileDataBiller.glo.products[i].name + " @ ₦" + this.$options.filters.moneyFormat(this.getMobileDataBiller.glo.products[i].amount);
                        sample.value = this.getMobileDataBiller.glo.products[i]

                        sdat.push(sample)

                        sample = {}
                    }
                    this.datbund = sdat;
                }
                else if (this.network.value === 'airtel'){
                    this.biller = ['BIL110', 'AIRTEL DATA BUNDLE', 'airtel' ];

                    for (let i = 0; i < this.getMobileDataBiller.airtel.products.length; i++){

                        sample.label = this.getMobileDataBiller.airtel.products[i].name + " @ ₦" + this.$options.filters.moneyFormat(this.getMobileDataBiller.airtel.products[i].amount);
                        sample.value = this.getMobileDataBiller.airtel.products[i]

                        sdat.push(sample)

                        sample = {}
                    }
                    this.datbund = sdat;
                }
                else if (this.network.value === '9mobile'){
                    this.biller = ['BIL111', '9MOBILE DATA BUNDLE', '9mobile' ];

                    for (let i = 0; i < this.getMobileDataBiller.nineMobile.products.length; i++){

                        sample.label = this.getMobileDataBiller.nineMobile.products[i].name + " @ ₦" + this.$options.filters.moneyFormat(this.getMobileDataBiller.nineMobile.products[i].amount);
                        sample.value = this.getMobileDataBiller.nineMobile.products[i]

                        sdat.push(sample)

                        sample = {}
                    }
                    this.datbund = sdat;
                }
            },


            fundsTransferStep1(){
                if (this.debitAcct === undefined || this.debitAcct === ''){
                    // display error notification
                    this.showAlert(true, 'error', 'Please Select Debit Account*')
                }
                else if (this.network === undefined || this.network === ''){
                    // display error notification
                    this.showAlert(true, 'error', 'Please Select a Network*')
                }
                else if (this.dataBundle === undefined || this.dataBundle === ''){
                    // display error notification
                    this.showAlert(true, 'error', 'Please Select a Data Bundle*')
                }
                else {
                    this.alert.show = false;


                    //    prepare the post Body
                    let pastBody ={
                        debitAcct:  this.debitAcct.value,
                        creditBank: this.network.label,
                        creditAccount: this.phonenumber,
                        amount: this.dataBundle.value.amount,
                        network: this.network,
                        bundle: this.dataBundle,
                        biller: this.biller,
                        showNarration: false,
                        confirmationType: 'Pay Bills',
                        confirmationTypeSub: 'Mobile Data',
                        transactionType: 'mobileData',
                        creditAccountName: this.phonenumber,
                        narration:  '',
                    }

                    // Save Details in the Store for Name Enquiry
                    this.updateConfirmationPageBody(pastBody);

                    // console.log('final PAST Body', pastBody);

                    //Update the current sub component in the store
                    this.updateInsideCurrentPage('confirmation')
                }

            },
            saveDetailsForNameEnquiry(){
                this.alert.show = false;

                //start app running
                this.updateAppLoading(true);

                axios
                    .post('/querycustomer',
                        {
                            querytype: 'mobilenumber',
                            accountnumber: '',
                            countrycode: this.phone.country,
                            mobilenumber: this.phone.number,
                        },
                        {
                            headers : {
                                'Authorization': this.getDataOnLogin.authorization,
                                'Content-Type': 'application/json',
                                'Access-Control-Allow-Origin': '*'
                            }})
                    .then(response => {
                        //stop app running
                        this.updateAppLoading(false);

                        let responseData =  response.data

                        if (responseData.responsecode === '00') {
                            //(IE) Account Exists
                            // console.log('Name Inquiry Response ==>', responseData)

                            let rubiesBankDetails = {
                                bankcode: "090175",
                                bankname: "HighStreet MFB",
                                nubancode: "32",
                            }

                            //    prepare the post Body
                            let pastBody ={
                                debitAcct:  this.debitAcct.value,
                                creditBank: rubiesBankDetails,
                                creditAccount: responseData.accountno,
                                amount: this.amount,
                                showNarration: true,
                                confirmationType: 'SEND MONEY CONFIRMATION',
                                confirmationTypeSub: 'To Phone Number',
                                transactionType: 'phoneTransfer',
                                creditAccountName: responseData.customername,
                                narration:  'Transfer from ' + this.debitAcct.value.accountname + ' to ' + responseData.customername,
                            }
                            // console.log('Post Body ===>>', pastBody)

                            // Save Details in the Store for Name Enquiry
                            this.updateConfirmationPageBody(pastBody);

                            // console.log('final PAST Body', pastBody);

                            //Update the current sub component in the store
                            this.updateInsideCurrentPage('confirmation')
                        }
                        else if (responseData.responsecode === '02') {
                            //(IE) Account Doesnt Exist
                            // console.log('Name Inquiry Response account doesnt exist ==>', responseData)

                            // this.postBody.creditAccountName = this.step1Response.accountname;
                            let rubiesBankDetails = {
                                bankcode: "090175",
                                bankname: "HighStreet MFB",
                                nubancode: "32",
                            }
                            //    prepare the post Body
                            let pastBody ={
                                debitAcct:  this.debitAcct.value,
                                creditBank: rubiesBankDetails,
                                creditAccount: this.phone.number,
                                countrycode: this.phone.country,
                                amount: this.amount,
                                showNarration: true,
                                confirmationType: 'SEND MONEY CONFIRMATION',
                                confirmationTypeSub: 'To Phone Number',
                                transactionType: 'phoneTransfer2',
                                creditAccountName: this.name,
                                narration:  'Transfer from ' + this.debitAcct.value.accountname + ' to ' + this.name,
                            }

                            // Save Details in the Store for Name Enquiry
                            this.updateConfirmationPageBody(pastBody);

                            // console.log('final PAST Body', pastBody);

                            //Update the current sub component in the store
                            this.updateInsideCurrentPage('confirmation')
                        }
                        else {
                            // this.FTResetAllInputField();

                            // display error notification
                            this.showAlert(true, 'error', responseData.responsemessage)
                        }
                    })
                    .catch(error => {
                        //stop app running
                        this.updateAppLoading(false);
                        this.closeModal('selectBankModal');


                        // clear form inputs
                        // console.log(error);

                        // display error notification
                        this.showAlert(true, 'error', 'Network Error')
                    })
            },
        },
        mounted(){
            this.$nextTick(()=>{
                $("input[data-type='currency']").on({
                    keyup: function() {
                        formatCurrency($(this));
                    },
                    blur: function() {
                        formatCurrency($(this), "blur");
                    }
                });

                function formatNumber(n) {
                    // format number 1000000 to 1,234,567
                    return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }

                function formatCurrency(input, blur) {
                    // appends $ to value, validates decimal side
                    // and puts cursor back in right position.

                    // get input value
                    var input_val = input.val();

                    // don't validate empty input
                    if (input_val === "") { return; }

                    // original length
                    var original_len = input_val.length;

                    // initial caret position
                    var caret_pos = input.prop("selectionStart");

                    // check for decimal
                    if (input_val.indexOf(".") >= 0) {
                        // get position of first decimal
                        // this prevents multiple decimals from
                        // being entered
                        var decimal_pos = input_val.indexOf(".");

                        // split number by decimal point
                        var left_side = input_val.substring(0, decimal_pos);
                        var right_side = input_val.substring(decimal_pos);

                        // add commas to left side of number
                        left_side = formatNumber(left_side);

                        // validate right side
                        right_side = formatNumber(right_side);

                        // On blur make sure 2 numbers after decimal
                        if (blur === "blur") {
                            right_side += "00";
                        }

                        // Limit decimal to only 2 digits
                        right_side = right_side.substring(0, 2);

                        // join number by .
                        input_val = "" + left_side + "." + right_side;
                    } else {
                        // no decimal entered
                        // add commas to number
                        // remove all non-digits
                        input_val = formatNumber(input_val);
                        input_val = "" + input_val;

                        // final formatting
                        if (blur === "blur") {
                            input_val += ".00";
                        }
                    }

                    // send updated string to input
                    input.val(input_val);

                    // put caret back in the right position
                    var updated_len = input_val.length;
                    caret_pos = updated_len - original_len + caret_pos;
                    input[0].setSelectionRange(caret_pos, caret_pos);
                }
            })
        },
    }
</script>

<style scoped>

</style>